import { render } from "./PaymentSlipBufferDetail.vue?vue&type=template&id=768fe92a&scoped=true"
import script from "./PaymentSlipBufferDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipBufferDetail.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-768fe92a"

export default script